import type { FaireProductEntity } from "../../entity_types/product";

export const ai_bulk_7: FaireProductEntity = {
  token: "ai_bulk_7",
  type: "product",
  name: "Purple/Yellow",
  brandName: "Ai Bulk Brand",
  imageUrl: "",
  priceDollars: 22.0,
  msrpDollars: 44.0,
  description: "",
  tags: ["women-owned"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
